import React, { Component } from 'react';
import { Layout } from '../../Common/Component';
import Step1 from './Step1';
import Step2 from './Step2';

class WizardMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      userCanProceedToCheckout: false,
      is_prepaid: false,
      prepay_months: null,
      is_footer: false,
      is_final_sidebar: false
    };
  }

  allowUserToProceedToCheckout(value) {
    this.setState({ userCanProceedToCheckout: value })
  }

  componentDidMount = () => {
    var self = this;
    setTimeout(() => {
      this.updateDimensions();
      window.addEventListener("resize", self.updateDimensions.bind(self));
    }, 500);
  }
  // Calculate dimensions
  updateDimensions() {
    var self = this;
    if (window.innerWidth <= 500) {
      //true
      self.setState({
        is_footer: true,

      })
    }
    else {
      self.setState({
        is_footer: false,
        is_final_sidebar: false
      })
    }
  }

  renderStep = () => {
    const { current, is_prepaid, prepay_months, is_footer, is_final_sidebar } = this.state;

    switch (current) {
    case 0:
      return (
        <Step1
          is_final_sidebar={is_final_sidebar}
          clearPricingCalc={this.props.clearPricingCalc}
          history={this.props.history}
          is_footer={is_footer}
          pricingCalculator={this.props.pricingCalculator}
          getPriceList={this.props.getPriceList}
          checkZipCode={this.props.checkZipCode}
          userCanProceedToCheckout={(value) => this.allowUserToProceedToCheckout(value)}
          is_prepaid={is_prepaid}
          prepay_months={prepay_months}
          nextPage={() => this.nextPage()}
          current={current}
          PriceList={this.props.PriceList}
          PricingCalc={this.props.PricingCalc}
          onPrepayChange={this.onPrepayChange}
          onPrepayTypeChange={(e) => this.onPrepayTypeChange(e)}
          ZipcodeCheck={this.props.ZipcodeCheck}
          updateCustomerLastCompletedStep={this.props.updateCustomerLastCompletedStep}
        />
      );
    case 1:
      return (
        <Step2
          is_footer={is_footer}
          ResRegister={this.props.ResRegister}
          getLeadById={this.props.getLeadById}
          checOutSidebar={() => { this.checOutSidebar() }}
          is_final_sidebar={is_final_sidebar}
          pricingCalculator={this.props.pricingCalculator}
          checkZipCode={this.props.checkZipCode}
          is_prepaid={is_prepaid}
          prepay_months={prepay_months}
          placeOrder={this.props.placeOrder}
          placeOrderInquery={this.props.placeOrderInquery}
          frequency={this.props.PricingCalc.data.frequency}
          current={current}
          OrderSubmit={this.props.OrderSubmit}
          ZipcodeCheck={this.props.ZipcodeCheck}
          next={e => this.next(e)}
          PricingCalc={this.props.PricingCalc}
          nextPage={() => this.nextPage()}
          history={this.props.history}
          onPrepayChange={(e) => this.onPrepayChange(e)}
          onPrepayTypeChange={(e) => this.onPrepayTypeChange(e)}
          getAccountInfo={this.props.getAccountInfo}
          AccountInfo={this.props.AccountInfo}
          checkEmail={this.props.checkEmail}
          emailInUse={this.props.emailInUse}
          getPreferredDays={this.props.getPreferredDays}
          PreferredDays={this.props.PreferredDays}
          updateLead={this.props.updateLead}
          getGeocodeAddress={this.props.getGeocodeAddress}
          resetGeocodeAddress={this.props.resetGeocodeAddress}
          GoogleApi={this.props.GoogleApi}
          updateCustomerLastCompletedStep={this.props.updateCustomerLastCompletedStep}
        />
      );
    default:
      return (
        <Step1
          history={this.props.history}
          pricingCalculator={this.props.pricingCalculator}
          getPriceList={this.props.getPriceList}
          checkZipCode={this.props.checkZipCode}
          userCanProceedToCheckout={(value) => this.allowUserToProceedToCheckout(value)}
          is_prepaid={is_prepaid}
          prepay_months={prepay_months}
          nextPage={() => this.nextPage()}
          current={current}
          PricingCalc={this.props.PricingCalc}
          onPrepayChange={this.onPrepayChange}
          onPrepayTypeChange={(e) => this.onPrepayTypeChange(e)}
          updateCustomerLastCompletedStep={this.props.updateCustomerLastCompletedStep}
        />
      );
    }
  };

  // prepay on change
  onPrepayChange = (e, hidePrepay = false) => {
    if (hidePrepay) {
      this.setState({ is_prepaid: false, prepay_months: null })
    } else {
      this.setState({ is_prepaid: !e.target.checked });

      if (!e.target.checked) {
        this.setState({ prepay_months: null });
      }
    }
  }

  onPrepayTypeChange = (e) => {
    this.setState({ prepay_months: e.target.value });
  }

  nextPage = () => {
    const { current } = this.state;
    this.setState({
      current: current === 0 ? 1 : current === 1 ? 1 : 1,
    });
  };

  // got to next step
  next = (e) => {
    this.setState({
      current: e,
      is_final_sidebar: false
    });
  };

  //Got to Mobile Final Sidebar
  checOutSidebar = () => {
    this.setState({
      is_final_sidebar: true
    })
  }
  render() {
    let { current, userCanProceedToCheckout, is_footer } = this.state;
    return (
      <Layout inProgress={this.props.inProgress && current === 1} noFooter={is_footer}>
        <div className="page_inner_content">
          <script src="https://fattjs.fattpay.com/js/fattmerchant.js"></script>
          <div className="wizard_form_wrapper res-flow">
            <div className="wizard_top_step">
              <div className="container">
                <ul>
                  <li
                    className={current >= 0 ? 'active' : ''}
                    onClick={() => this.next(0)}>
                    <span> 1</span>
                    {!is_footer || current === 0 ? <label>GET A QUOTE</label> : ''}
                  </li>
                  <li
                    className={current === 1 ? 'active' : ''}
                    onClick={() => {
                      if (!userCanProceedToCheckout) return;
                      this.next(1);
                    }}
                  >
                    <span>2</span>
                    {!is_footer || current === 1 ? <label>CHECK OUT</label> : ''}
                  </li>

                </ul>
              </div>
            </div>
            <div className="container">
              {this.renderStep()}
            </div>
          </div>
        </div>
      </Layout>

    );
  }
}

export default WizardMain;
